/** TRULY brand palette — mirrors config/brand_config.yaml visual.colors */
export const colors = {
  blue: "#0000FF",
  blueDeep: "#0000CC",
  purple: "#9B00FF",
  purpleDeep: "#6D00B3",
  magenta: "#FF00FF",
  red: "#FF0000",
  beige: "#F5F0E8",
  beigeDeep: "#E8DFCC",
  textDark: "#1A1A1A",
  textLight: "#F5F0E8",
} as const;

/** Score color bands match scripts/build_gallery.py score_color(). */
export const scoreColor = (score: number | null | undefined): string => {
  if (score == null) return "#C03030";
  if (score >= 85) return "#1B8F3A";
  if (score >= 70) return "#C49A00";
  return "#C03030";
};
